import React from 'react';
import PropTypes from 'prop-types';
import Button from '../../atoms/Button';
import './ButtonGroup.css';

const ButtonGroup = ({options, value, onChange, small}) => {
  return (
    <div className="ButtonGroup">
      {options.map(opt => {
        const selectOpt = () => {
          onChange(opt.value);
        };
        const selected = opt.value === value;
        return (
          <Button
            key={opt.value}
            selected={selected}
            onClick={selectOpt}
            small={small}
          >
            {opt.label}
          </Button>
        )
      })}
    </div>
  )
};

ButtonGroup.defaultProps = {
  small: false,
};

ButtonGroup.propTypes = {
  options: PropTypes.arrayOf(PropTypes.shape({
    value: PropTypes.any,
    label: PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.node,
    ]),
  })),
  value: PropTypes.any,
  onChange: PropTypes.func.isRequired,
  small: PropTypes.bool.isRequired,
};

export default ButtonGroup;



// WEBPACK FOOTER //
// ./src/component/molecules/ButtonGroup/index.js